import { Routes } from '@angular/router';
import { authGuard, roleGuard } from '../../guards/auth.guard';
import { UserRoles } from '@shared/models/user-roles';

export const measurementsRoutes: Routes = [
  {
    path: 'measurements',
    title: 'Einheiten',
    loadComponent: () =>
      import('./measurements-list/measurements-list').then(m => m.MeasurementsListComponent),
    canActivate: [authGuard],
  },
  {
    path: 'measurements/new',
    title: 'Neue Einheit',
    loadComponent: () =>
      import('./measurement-form/measurement-form').then(m => m.MeasurementFormComponent),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'measurements/:id/edit',
    title: 'Einheit bearbeiten',
    loadComponent: () =>
      import('./measurement-form/measurement-form').then(m => m.MeasurementFormComponent),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
];
